interface BanderaProps {
  grupo?: string;
  nombre: string;
  alt: string;
  className?: string;
  size?: number;
}

const Bandera = ({
  grupo,
  nombre,
  alt,
  className = "bandera",
  size,
}: BanderaProps) => {
  const baseUrl = "/banderas";

  const src = grupo
  ? `${baseUrl}/${grupo}/${nombre}.webp`
  : `${baseUrl}/${nombre}.webp`;

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      width={size}
      height={size}
    />
  );
};

export default Bandera;